import React from 'react';
import styled from '../../styled';
const Container = styled.div `
  display: inline-block;
  padding: 1rem 0.5rem 0.8125rem;
  cursor: ${({ theme, isActive, isDisabled }) => theme.tabs.normal.cursor({ isActive, isDisabled })};
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  text-shadow: ${({ theme, isActive }) => theme.tabs.normal.textShadow({ isActive })};
  color: ${({ theme, isActive, isDisabled, isError }) => theme.colors[theme.tabs.normal.textColor({ isActive, isDisabled, isError })]};
  border-bottom-style: solid;
  border-bottom-width: 0.1875rem;
  border-bottom-color: ${({ theme, isActive, isDisabled, isError }) => theme.colors[theme.tabs.normal.borderColor({ isActive, isDisabled, isError })] || theme.tabs.normal.borderColor({ isActive, isDisabled, isError })};

  &:hover {
    color: ${({ theme, isActive, isDisabled, isError }) => theme.colors[theme.tabs.hover.textColor({ isActive, isDisabled, isError })]};
    border-bottom-color: ${({ theme, isActive, isDisabled, isError }) => theme.colors[theme.tabs.hover.borderColor({ isActive, isDisabled, isError })] || theme.tabs.hover.borderColor({ isActive, isDisabled, isError })};
  }
`;
const Tab = ({ label, isActive = false, isDisabled = false, isError = false, onClick, }) => {
    return (React.createElement(Container, { onClick: isDisabled || isActive ? undefined : onClick, isActive: isActive, isDisabled: isDisabled, isError: isError }, label));
};
export default Tab;
//# sourceMappingURL=Tab.js.map